import { isDirty } from 'redux-form'
import * as Effects from 'redux-saga/effects'
import toggleNewVersionModal from '../../../actions/synchronize/toggleNewVersionModal'
import { driver, names } from '../../../database/localStorage'
import {
  getModalCreateReservationIsOpen,
  getModalUpdateReservationIsOpen,
} from '../../../reducers/bookingCalendar/selectors/getModalOpen'
import getModals from '../../../reducers/modals/selectors/getModals'
import { SynchronizeActions } from '../../../reducers/synchronize/actionNames'
import getInfoModalIsOpen from '../../../reducers/userAccount/selectors/infoModal'
import { getModalLimitIsOpen } from '../../../reducers/userAccount/selectors/limitModal'

function* newVersion(action) {
  const modals = yield Effects.select(getModals)
  const updateReservation = yield Effects.select(
    getModalUpdateReservationIsOpen,
  )
  const createReservation = yield Effects.select(
    getModalCreateReservationIsOpen,
  )
  const limitModal = yield Effects.select(getModalLimitIsOpen)
  const infoModal = yield Effects.select(getInfoModalIsOpen)
  const profile = yield Effects.select(isDirty('profile'))
  const settings = yield Effects.select(isDirty('settings'))

  if (
    modals.length !== 0 ||
    updateReservation ||
    createReservation ||
    limitModal ||
    infoModal ||
    profile ||
    settings
  ) {
    yield Effects.delay(5000)
    return yield Effects.put(action)
  }

  driver.setItem(names.UserAccountStorage.Version, action.version.version)
  driver.setItem(names.UserAccountStorage.DbVersion, action.version.dbVersion)
  yield Effects.put(toggleNewVersionModal(action.version.version))
}

export default function* () {
  yield Effects.takeEvery(SynchronizeActions.NewVersion, newVersion)
}
